import { render, staticRenderFns } from "./AppBar.vue?vue&type=template&id=8b4f01a8&scoped=true"
import script from "./AppBar.vue?vue&type=script&lang=ts"
export * from "./AppBar.vue?vue&type=script&lang=ts"
import style0 from "./AppBar.vue?vue&type=style&index=0&id=8b4f01a8&prod&scoped=true&lang=scss"
import style1 from "./AppBar.vue?vue&type=style&index=1&id=8b4f01a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4f01a8",
  null
  
)

export default component.exports